import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ListItemText from '@mui/material/ListItemText';
import {
  Accordion,
  AccordionSummary,
  Alert,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Pagination,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ListContainer from '../components/ListContainer';
import AccordionDetails from '@mui/material/AccordionDetails';
import {
  useGetNewsQuery,
} from '../slices/historyApiSlice';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import News from '../components/News';
import PeriodPicker from '../components/PeriodPicker';
import ItemsViewer from '../components/Common/ItemsViewer';


const HistoryScreen = () => {
  const rootUrl = 'api';
  const directories = 'directories';
  const slug = 'news';
  const { userInfo, permissions } = useSelector((state) => state.auth);

  const perm = {
    canRead: userInfo?.isAdmin || !!permissions?.[slug]?.read,
    canCreate: false, //userInfo?.isAdmin || !!permissions?.[slug]?.create,
    canUpdate: false, //userInfo?.isAdmin || !!permissions?.[slug]?.update,
    canDelete: false, //userInfo?.isAdmin || !!permissions?.[slug]?.delete,
  };

  const pagination = { usePagination: true, url: '/news' };

  return (
    <ItemsViewer
      rootUrl={rootUrl}
      section={directories}
      slug={slug}
      permissions={perm}
      pagination={pagination}
    />
  );
};

export default HistoryScreen;
